import React from 'react'
import PropTypes from 'prop-types'
import Spinner from 'react-spinkit'

const stylesFixed = {
  position: 'fixed',
  top: '50%',
  left: '50%',
}

const stylesAbs = {
  position: 'absolute',
  top: '50%',
  left: '50%',
}

const LoadingSpinner = ({ isAbs }) => {
  const selectedStyles = isAbs ? stylesAbs : stylesFixed

  return (
    <Spinner
      spinnerName="rotating-plane"
      style={selectedStyles}
    />
  )
}

LoadingSpinner.defaultProps = {
  isAbs: false,
}

LoadingSpinner.propTypes = {
  isAbs: PropTypes.bool,
}

export default LoadingSpinner



// WEBPACK FOOTER //
// ./src/components/sitewide/Spinner.js